/**
 * The identifier of the sound to be played when we got event for talking while muted.
 *
 * @type {string}
 */
export const TALK_WHILE_MUTED_SOUND_ID = 'TALK_WHILE_MUTED_SOUND_ID';
